import CheckPayment from './CheckPayment';
import styles from './css/NavBar.module.css'
import MakePayment from './MakePayment';

const NavBar = () => {
  return (
    <nav className={`${styles.navbar}`}>
      <div className='d-flex align-items-center'>
        <div className={`${styles.navbarTitle} primary-text`}>PPGC GOLD V2</div>
        <div className={`${styles.navItems} d-flex align-items-center`}>
          <a href="#about-us" >About</a>
          <a href="https://drive.google.com/file/d/1r8Lp-Z4JSpHAtOOKGNvdSg8ctQjpMJDu/view?usp=drivesdk">Whitepaper</a>
          <a href="#token-section">Tokemonics</a>
          <a href="#roadmap_">Roadmaps</a>
          <MakePayment />
          {/* <CheckPayment /> */}
          {/* <button className='btn btn-warning rounded-0 text-white fw-bold'>BUY NOW</button> */}
        </div>
      </div>
    </nav>
  )
}

export default NavBar;